import moment from 'moment-timezone';

export const formatDateTime = (
  isoString,
  timezone = 'Asia/Seoul',
  format = 'YYYY-MM-DD HH:mm:ss'
) => {
  return moment.utc(isoString).tz(timezone).format(format);
};

/**
 * 다국어 지원 날짜 포맷팅
 * @param dateString - 날짜 문자열 (ISO 형식 또는 YYYY-MM-DD)
 * @param lang - 언어 코드 ('ko', 'en', 등)
 * @param includeTime - 시간 포함 여부
 * @returns 포맷된 날짜 문자열
 */
export const formatLocalizedDate = (
  dateString: string | Date,
  lang: string = 'en',
  includeTime: boolean = false
): string => {
  const date = typeof dateString === 'string' ? new Date(dateString) : dateString;

  if (isNaN(date.getTime())) {
    return dateString as string;
  }

  const isKorean = lang === 'ko' || lang.startsWith('ko-');

  if (isKorean) {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();

    if (includeTime) {
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      return `${year}년 ${month}월 ${day}일 ${hours}:${minutes}`;
    }
    return `${year}년 ${month}월 ${day}일`;
  }

  // 영어 및 기타 언어
  const options: Intl.DateTimeFormatOptions = includeTime
    ? { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' }
    : { year: 'numeric', month: 'long', day: 'numeric' };

  return date.toLocaleDateString('en-US', options);
};
